import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-brand/30 bg-ink py-5">
      <div className="marquee-track flex items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-mono text-xs uppercase tracking-[0.4em] text-[#F6F1E7]/60">{item}</span>
            <span className="text-brand-bright/70">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
